import { styled } from "@mui/material/styles";

// Components
import { Box, Modal } from "@mui/material";

const styledName = "WalletList";

export const StyledListWrapper = styled(Box, { name: styledName })({
  "&": {
    width: "fit-content",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "x 0.3 ease-in-out",
  },
});

export const StyledWalletList = styled("div", { name: styledName })({
  "&": {
    overflowY: "scroll",
    scrollBehavior: "smooth",
    padding: "0 10px",
    flexGrow: "1",
  },
  // flexShrink: "1",
});

export const StyledModal = styled(Modal, { name: styledName })({
  "&": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
